import React from 'react'
import { useState } from 'react'
import '../css/news.css'
import notfound from './imagenotfound.jpg'


function News(props) {
  const [nf,setnf]=useState(notfound)
  return (
<div>
    <section className='news-elem'>
   <img src={props.data.urlToImage?props.data.urlToImage:nf} alt="image not found" className='img'/>
   <h4 className='desc'> {props.data.description?props.data.description:'heading missing !'}</h4> 
  <p className='cont'>{props.data.content}</p>
     <p className="date_author">
             published by:{props.data.author?props.data.author:'unknown author'} on{" "}
             {new Date(props.data.publishedAt).toLocaleString()}
          </p>
  <button className="btn">
                <a href={props.data.url} target="_blank">read more</a>
              </button>
    </section>
   </div>
    )
}

export default News